export function initMobileNavigationSlot() {
    const slot = document.querySelector(".js-mobile-navigation-slot");
    const panels = [...document.querySelectorAll(".js-show-in-menu")];
    if (!slot) return;

    panels.forEach(panel => {
        const clone = panel.cloneNode(true); // deep clone with children
        slot.appendChild(clone); // inserts copy into slot
    });
}